<template>
  <div class="flex w-full flex-col space-y-8">
    <DocumentPage
      v-for="page in totalPage"
      :ref="setDocumentPageRef"
      :page-number="page"
      :is-presenting="presentingPageNumbers.includes(page)"
      :get-text-content-canvas-context="getTextContentCanvasContext"
      :get-text-content-ascent="getTextContentAscent"
    />
  </div>
</template>

<script setup>
import { inject, shallowRef, onBeforeMount } from "vue"

import { useSetupDocument } from "../../composables/pdf-viewer/setupDocument"

import DocumentPage from "./DocumentPage.vue"

const documentPages = shallowRef([])
let _tempDocumentPages = []

const containerState = inject("CONTAINER_STATE")
const pagingState = inject("PAGING_STATE")
const scalingState = inject("SCALING_STATE")

const { totalPage } = pagingState

const setDocumentPageRef = component => {
  if (!component) return

  _tempDocumentPages.push(component.$el)
  if (_tempDocumentPages.length === totalPage.value) {
    documentPages.value = _tempDocumentPages
  }
}

onBeforeMount(() => {
  documentPages.value = []
  _tempDocumentPages = []
})

const { presentingPageNumbers, getTextContentCanvasContext, getTextContentAscent } = useSetupDocument({
  containerState,
  pagingState,
  scalingState,
  documentPages
})
</script>
